import React, { type MouseEvent } from "react";
import { type DPDay, useContextCalendars, useContextDaysPropGetters } from "@rehookify/datepicker";
import { twJoin } from "tailwind-merge";

import { SupText } from "../../../../components/UI/Text";

interface DayPicker {
  days: DPDay[];
  onDayPick?: (date?: Date) => void;
}

export function DayPicker({ days, onDayPick }: DayPicker) {
  const { weekDays } = useContextCalendars();
  const { dayButton } = useContextDaysPropGetters();

  function handleDayClick(_: MouseEvent<HTMLElement>, date: Date) {
    onDayPick?.(date);
  }

  return (
    <div className="sup-day-picker px-2">
      <div className="grid grid-cols-[repeat(7,2.25rem)] justify-between py-2 w-64">
        {weekDays.map(d => (
          <SupText key={d} as="span" variant="subtitle2" weight="bold" className="leading-9 text-center">
            {d}
          </SupText>
        ))}
      </div>

      <div className="grid grid-cols-[repeat(7,2.25rem)] justify-between gap-y-2 py-2 w-64">
        {days.map(d => {
          return (
            <SupText
              key={d.$date.getTime()}
              as="button"
              variant="subtitle2"
              disabled={d.disabled || !d.inCurrentMonth}
              className={twJoin(
                "leading-9 transition-colors duration-200 disabled:opacity-44",
                d.selected ? "bg-primary-300 text-neutral-900" : "enabled:hover:bg-primary-100 enabled:hover:text-neutral-900"
              )}
              {...dayButton(d, { onClick: handleDayClick })}
            >
              {d.day}
            </SupText>
          );
        })}
      </div>
    </div>
  );
}
